<template>
  <div>
    <MobileButtonGroup :buttons="profileLegalDocuments" />
    <div
      v-if="
        isUcb && profileLegalDocuments.findIndex(doc => doc.documentName === 'termsConditions') > -1
      "
      class="text-body-small mt-8"
    >
      <i18n path="profile.ucb.text">
        <template #terms_and_conditions>
          <span
            class="link--inline"
            @click="
              () =>
                profileLegalDocuments.find(doc => doc.documentName === 'termsConditions').click()
            "
            >{{ $t('profile.ucb.termsAndConditions') }}</span
          >
        </template>
      </i18n>
    </div>
  </div>
</template>

<script>
import profileDocuments from '@/mixins/profileDocuments';
import checkPartner from '@/mixins/checkPartner';
import MobileButtonGroup from '@/components/Atoms/MobileButtonGroup';

export default {
  name: 'DocumentsMobile',
  components: { MobileButtonGroup },
  mixins: [checkPartner, profileDocuments]
};
</script>
